export default {
	"detailSplitDialog": {
		"relationCheckboxLable": "whether the quantity of goods and the number of packages are related to modification",
		"initialization": "Greater than 0 and cannot exceed the initialization value",
		"confirmedSplit": "confirm split"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/detailSplitDialog/detailSplitDialog.js